import { apiSlice } from "../api/apiSlice";
import socket from "../../utils/socket";

export const messagesApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getMessages: builder.query({
            query: ({ id, email }) =>
                `/messages?conversationId=${id}&_sort=timestamp&_order=desc&_page=1&_limit=${process.env.REACT_APP_MESSAGES_PER_PAGE}`,

            transformResponse(apiResponse, meta) {
                const totalCount = meta.response.headers.get("X-Total-Count");
                return {
                    data: apiResponse,
                    totalCount,
                };
            },
            async onCacheEntryAdded(
                arg,
                { updateCachedData, cacheDataLoaded, cacheEntryRemoved }
            ) {
                try {
                    await cacheDataLoaded;
                    socket.on("message", (data) => {
                        updateCachedData((draft) => {
                            if (
                                (data.data.receiver.email === arg.email ||
                                    data.data.sender.email === arg.email) &&
                                data.data.conversationId == arg.id
                            ) {
                                draft.data.push(data.data);
                            }
                        });
                    });
                } catch (err) {}

                await cacheEntryRemoved;
                // socket.close();
            },
        }),
        getMoreMessages: builder.query({
            query: ({ id, page, email }) =>
                `/messages?conversationId=${id}&_sort=timestamp&_order=desc&_page=${page}&_limit=${process.env.REACT_APP_MESSAGES_PER_PAGE}`,
            async onQueryStarted({ id, email }, { queryFulfilled, dispatch }) {
                try {
                    const messages = await queryFulfilled;

                    if (messages?.data?.length > 0) {
                        // update conversation cache pessimistically start
                        dispatch(
                            apiSlice.util.updateQueryData(
                                "getMessages",
                                { id, email },
                                (draft) => {
                                    return {
                                        data: [...draft.data, ...messages.data],
                                        totalCount: Number(draft.totalCount),
                                    };
                                }
                            )
                        );
                        // update messages cache pessimistically end
                    }
                } catch (err) {}
            },
        }),
        addMessage: builder.mutation({
            query: (data) => ({
                url: "/messages",
                method: "POST",
                body: data,
            }),
        }),
    }),
});

export const { useGetMessagesQuery, useAddMessageMutation } = messagesApi;
